// src/index.js

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import { AuthProvider } from './AuthProvider.jsx';
import './dashboard.css';
import './index.css';
import './styles/app/app.scss';
ReactDOM.render(
  <AuthProvider>
    <App />
  </AuthProvider>,
  document.getElementById('root')
);